module.exports = __webpack_public_path__ + "img/vip.6f6500cd.png";